/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  PayoutPixTypes,
  PayoutPixTypeState
} from '@/store/interfaces/payoutPixType';
import { RootState } from '@/store/interfaces/rootState';
import payoutPixTypeType from '@/store/types/payoutPixType';
import { httpCommpix } from '@/util/HTTPCommpix';
import { AxiosError, AxiosResponse } from 'axios';
import { ActionTree, GetterTree, MutationTree } from 'vuex';

const namespaced = true;

const initialState = (): PayoutPixTypeState => {
  return {
    payoutPixTypesList: [],
  };
};

const state: PayoutPixTypeState = initialState();

const getters: GetterTree<PayoutPixTypeState, RootState> = {
  [payoutPixTypeType.getters.GET_PAYOUT_PIX_TYPES_LIST]: state => {
    return state.payoutPixTypesList;
  },
};

const mutations: MutationTree<PayoutPixTypeState> = {
  reset: (state: any) => {
    const initialStateFields: any = initialState();
    Object.keys(initialStateFields).forEach((key: any) => {
      state[key] = initialStateFields[key];
    });
  },

  [payoutPixTypeType.mutations.SET_PAYOUT_PIX_TYPES_LIST]: (
    state,
    states: Array<PayoutPixTypes>
  ) => {
    const payoutPixTypes: Array<PayoutPixTypes> = states;

    state.payoutPixTypesList = payoutPixTypes;
  },
};

const actions: ActionTree<PayoutPixTypeState, RootState> = {
  [payoutPixTypeType.actions.PAYOUT_PIX_TYPES_LIST]: (
    { commit, }
  ) => {
    return new Promise((resolve, reject) => {
      httpCommpix
        .get('/payout-pix-types')
        .then((res: AxiosResponse) => {
          commit(
            payoutPixTypeType.mutations.SET_PAYOUT_PIX_TYPES_LIST,
            res.data
          );
          resolve(res);
        })
        .catch((error: AxiosError) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced,
  state,
  getters,
  mutations,
  actions,
};
